/**
 * Created by hp on 2017/8/29.
 */
import React, {Component} from 'react';
import {Cell, CellBody, CellFooter} from 'react-weui';


class WKCell extends Component {
    render() {
        const {title, href = "javascript:;", handleClick = null} = this.props;
        return (
            <Cell href={href} access onClick={handleClick}>
                <CellBody>{title}</CellBody>
                <CellFooter/>
            </Cell>
        )
    }
}

export default WKCell;


// WEBPACK FOOTER //
// ./src/components/wk/WKCell.js